export default __webpack_public_path__ + "static/4-6355407dae1b68154ee019b063d34820.jpeg";